import Checkmark from '../../../../components/svg/checkmark'

export default function ListItemCheckbox({ value, checked, children, onChange, ...restProps }) {
  return (
    <li {...restProps}>
      <button className='flatBtn' onClick={() => onChange(value, !checked)}>
        {children}
        {checked && <Checkmark className='checkmark' fill='var(--primary-color)' width='20' />}
      </button>

      <style jsx>{`
        li {
          padding: 0.2rem;
          list-style: none;
          border-bottom: 0.1rem solid var(--separator-line-color);

          button {
            position: relative;
            display: block;
            width: 100%;
            height: 5.8rem;
            padding: 0 4rem 0 0;
            text-align: left;
            color: var(--primary-bg-color);
            font-size: 1.6rem;
            font-weight: 700;

            :global(.checkmark) {
              position: absolute;
              top: 50%;
              right: 1rem;
              transform: translateY(-50%);
            }
          }
        }

        @media (max-width: 1024px) {
          li {
            button {
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </li>
  )
}
